import { MotionConfig } from 'motion/react'
import { ErrorBoundary } from 'react-error-boundary'
import { GlobalErrorFallback, logError } from '@/modules/errors'

export const Providers = ({ children }: { children: React.ReactNode }) => {
  return (
    <ErrorBoundary fallbackRender={GlobalErrorFallback} onError={logError}>
      <MotionConfig reducedMotion='user'>{children}</MotionConfig>
    </ErrorBoundary>
  )
}
